import React,{useEffect,useState,useRef} from 'react'
import '../styles/notifications.css'
import * as actions from '../data/massage_data'
import * as normallActions from '../store/actions'
import * as actions2 from '../data/follow_data'
import {useSelector,useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom';
import {EmptyMassage} from '../comps/comps'
import {Helmet} from "react-helmet";
import * as authAction from '../store/authAction'
 import { BsTrash} from 'react-icons/bs';
  import { FiMessageSquare} from 'react-icons/fi';
  import { BiSearch} from 'react-icons/bi';
import FriendPart from '../comps/friendPart'
import UserAvatar from '../comps/userAvatar'
import {getSocket} from '../store/socketClient'
import StoryViewer from '../comps/storyViewer'
import StoriesRail from '../comps/storiesRail'
import { fetchUserStory, hasStory } from '../utils/story'
import { promptState, subscribeAndStore } from '../comps/noti'
import { mediaPreviewLabel } from '../utils/chatMedia'
import { bindStoryChrome } from '../utils/storyChrome'
import { voteCommunityJoin } from '../data/communities_data'
import { uploadUrl } from '../utils/postImages'

const formatNotificationDate = (value) => {
  if (value == null || value === '') return '';
  const raw = String(value);
  const parsed = /^\d+$/.test(raw) ? new Date(Number(raw)) : new Date(value);
  if (Number.isNaN(parsed.getTime())) return raw;

  const now = new Date();
  const start = (d) => {
    const copy = new Date(d);
    copy.setHours(0, 0, 0, 0);
    return copy.getTime();
  };
  const dayDiff = Math.round((start(now) - start(parsed)) / 86400000);

  if (dayDiff === 0) return parsed.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  if (dayDiff === 1) return 'Yesterday';
  if (dayDiff > 1 && dayDiff < 7) return parsed.toLocaleDateString([], { weekday: 'short' });

  return parsed.toLocaleDateString([], {
    month: 'short',
    day: 'numeric',
    year: parsed.getFullYear() === now.getFullYear() ? undefined : 'numeric'
  });
};

const parseLikeNotice = (text) => {
  const parts = String(text || '').split('|')
  if (parts[0] !== 'LIKE' || parts.length < 4) return null
  return { kind: parts[1], url: parts[2], name: parts.slice(3).join('|') }
}

// ACT|kind|url|name|photo|thumbnail|snippet|thing  (someone liked / commented on / replied to something of yours)
const parseActNotice = (text) => {
  const parts = String(text || '').split('|')
  if (parts[0] !== 'ACT' || parts.length < 8) return null
  return { kind: parts[1], url: parts[2], name: parts[3], photo: parts[4], thumb: parts[5], snippet: parts[6], thing: parts[7] || 'video' }
}

const actLine = (act) => {
  const said = act.snippet ? `: ${act.snippet}` : ''
  if (act.kind === 'comment') return `commented on your ${act.thing}${said}`
  if (act.kind === 'reply') return `replied to your comment${said}`
  if (act.kind === 'commentlike') return `liked your comment${said}`
  return `liked your ${act.thing}`
}

const previewMessage = (text) => {
  const raw = String(text || '')
  const act = parseActNotice(raw)
  if (act) return actLine(act)
  const like = parseLikeNotice(raw)
  if (like) return `${like.name} liked your ${like.kind}`
  const parts = raw.split('|')
  if (parts[0] === 'JOIN' && parts.length >= 4) return mediaPreviewLabel(parts.slice(3).join('|'))
  return mediaPreviewLabel(raw)
}

const parseJoinAsk = (text) => {
  const match = String(text || '').match(/^JOIN\|([^|]+)\|([^|]+)\|/)
  if (!match) return null
  return { communityId: match[1], applicant: match[2] }
}

const Notifications = () =>{
  const [isload,setLoad] = useState(true);
  const [editing, setEditing] = useState(false);
  const [storyItem, setStoryItem] = useState(null);
  const [pushBusy, setPushBusy] = useState(false);
  const [pushHint, setPushHint] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(()=>{
    const loadNotifications = async () => {
      const userData = localStorage.getItem('userdata');
      try {
        if(userData){
          const {id,pid} = JSON.parse(userData);
          await dispatch(authAction.auth(id,pid));
          await dispatch(actions.get_massage());
          await dispatch(actions2.get_follow());
        }
      } finally {
        setLoad(false);
      }
    }
    loadNotifications();
  },[dispatch])
  const userId = useSelector(state => state.authReduse.id);
  const listt = useSelector(state => state.UsersReduse.massages);
  const listtt = useSelector(state => state.followReduse.follow);
const translations = useSelector(state => state.lang_reduse.lang);
  const [storiesByUser, setStoriesByUser] = useState({});
  const [chromeVisible, setChromeVisible] = useState(true);
  const [peekHost, setPeekHost] = useState(null);
  const scrollRef = useRef(null);
  const chrome = useRef(null);

  useEffect(() => {
    chrome.current = bindStoryChrome(setChromeVisible);
    return () => chrome.current?.destroy();
  }, []);

  const storyUserIds = listt.map(item => item.type).join(',');

  useEffect(() => {
    if (!storyUserIds) return undefined;
    let cancelled = false;
    const ids = [...new Set(storyUserIds.split(',').filter(Boolean))];
    const loadStories = async () => {
      const next = {};
      await Promise.all(ids.map(async (id) => {
        const fromList = listt.find(item => String(item.type) === String(id) && hasStory(item.story));
        if (fromList) {
          next[id] = fromList.story;
          return;
        }
        const fromFollow = listtt.find(user => String(user.userid) === String(id) || String(user.id) === String(id));
        if (hasStory(fromFollow?.story)) {
          next[id] = fromFollow.story;
          return;
        }
        const story = await fetchUserStory(id);
        next[id] = hasStory(story) ? story : '';
      }));
      if (!cancelled) setStoriesByUser(next);
    };
    loadStories();
    return () => { cancelled = true };
  }, [storyUserIds, listtt, listt]);

  const storyFor = (item) => {
    if (hasStory(item.story)) return item.story;
    if (hasStory(storiesByUser[item.type])) return storiesByUser[item.type];
    const follow = listtt.find(user => String(user.userid) === String(item.type) || String(user.id) === String(item.type));
    return follow?.story || '';
  };

  useEffect(() => {
    if (!userId) return undefined;
    const refresh = () => dispatch(actions.get_massage());
    const socket = getSocket();
    const onMessage = (message) => {
      if (!message) return;
      if (String(message.to_user) === String(userId) || String(message.from_user) === String(userId)) {
        refresh();
      }
    };
    socket.on('send message', onMessage);
    // Socket handles realtime updates; poll only as a slow fallback.
    const interval = socket.connected ? null : window.setInterval(refresh, 30000);
    return () => {
      socket.off('send message', onMessage);
      if (interval) window.clearInterval(interval);
    };
  }, [dispatch, userId]);
  return(
<section
  className='Notifications'
  onWheel={event => chrome.current?.onWheel(event)}
  onTouchStart={event => chrome.current?.onTouchStart(event)}
  onTouchMove={event => chrome.current?.onTouchMove(event)}
>
  <Helmet>
  <title>Pinweelo Notifications</title>
    <meta name="theme-color" content="#FFFFFF" />
<meta name="description" content='here you can check your notifications '/>
<meta name='keywords' content='notifications,messages,pinweelo website,notifications page'/>
 <link rel="canonical" href="https://pinweelo.com/notifications" />
  </Helmet>
    <FriendPart />
    <StoryViewer
      open={Boolean(storyItem)}
      onClose={() => setStoryItem(null)}
      media={storyItem?.story}
      name={storyItem?.userName}
      photo={storyItem?.userImg}
    />
  <figure>
    <button type="button" className={`liqudframe${editing ? ' isActive' : ''}`} onClick={() => setEditing(on => !on)}>
      {editing ? 'Done' : 'Edit'}
    </button>
    <p className='nofTitle'><i><FiMessageSquare /></i> {translations.messages}<span className="nofStoryPeekHost" ref={setPeekHost} /></p>
    <p className='liqudframe' onClick={() => {navigate(`../search`)}}><BiSearch /></p>
  </figure>
  <div
    className="notificationsScroll"
    ref={scrollRef}
    onScroll={() => chrome.current?.onScroll(scrollRef.current)}
    onWheel={event => chrome.current?.onWheel(event)}
    onTouchStart={event => chrome.current?.onTouchStart(event)}
    onTouchMove={event => chrome.current?.onTouchMove(event)}
  >
  <StoriesRail variant="inbox" hidden={!chromeVisible} peekHost={peekHost} />
  {userId && promptState() !== 'refresh' && (
    <div className="pushEnableBar">
      <button
        type="button"
        disabled={pushBusy}
        onClick={async () => {
          setPushBusy(true)
          setPushHint('')
          try {
            const result = await subscribeAndStore(userId)
            setPushHint(result.ok ? 'Alerts are on.' : 'Allow notifications in your browser settings, then try again.')
          } catch (_) {
            setPushHint('Could not turn on alerts.')
          } finally {
            setPushBusy(false)
          }
        }}
      >
        {pushBusy ? 'Turning on…' : 'Turn on alerts'}
      </button>
      {pushHint ? <p>{pushHint}</p> : null}
    </div>
  )}
<div className="notificationsWindow"><span>{translations.from}</span><span>{translations.hint}</span><span>{translations.date}</span><span>{translations.delete}</span><span>{translations.go}</span></div>
  <EmptyMassage loading={!!isload && (!listt || listt.length === 0)} list={listt} title={translations.thereisnonotifications} /> 
{(listt || []).map((item)=>{
const isSystem = item.type === 'pinweelo-system' || item.type === 'pinweelo'
const likeNotice = isSystem ? parseLikeNotice(item.nof) : null
const act = isSystem ? parseActNotice(item.nof) : null
const communityMatch = String(item.nof || '').match(/\/community\/([A-Za-z0-9_-]+)/)
const contentPath = String(item.nof || '').match(/(\/(?:community|video|post|sound)\/[^\s|]+|\/watch\?[^\s|]+)/)
const joinAsk = isSystem ? parseJoinAsk(item.nof) : null
const liveStory = storyFor(item);
return(
<div key={item.id}>

<div className={`nof${editing ? ' isEditing' : ''}${isSystem ? ' isSystem' : ''}${act ? ' isAct' : ''}`} onClick={() => {
  if (editing) return
  if (joinAsk) return
  if (act && act.url) navigate(act.url)
  else if (likeNotice && likeNotice.url) navigate(likeNotice.url)
  else if (communityMatch) navigate(communityMatch[0])
  else if (contentPath) navigate(contentPath[1])
  else if (!isSystem) navigate(`../chat/${item.type}`)
}}><span className='nof-leftsec'><figcaption className={`imgRap${hasStory(liveStory) ? ' hasStory' : ''}`} onClick={async (event) => {
  event.stopPropagation();
  if (editing || isSystem) return;
  if (hasStory(liveStory)) {
    setStoryItem({ ...item, story: liveStory });
    return;
  }
  const story = await fetchUserStory(item.type);
  if (hasStory(story)) setStoryItem({ ...item, story });
  else navigate(`../@${item.type}`);
}}><UserAvatar alt="" name={act ? act.name : likeNotice ? likeNotice.name : (item.userName || (isSystem ? 'Pinweelo' : item.type))} src={act ? act.photo : isSystem ? (item.userImg || '/icon-192.png') : item.userImg} /></figcaption><div className="nofline"><p>{act ? act.name : likeNotice ? likeNotice.name : (item.userName || item.type || 'Unknown')}</p> <p className="dateinfo">{previewMessage(item.nof)}</p></div></span>
{act && act.thumb ? (
  <img
    className="nofThumb"
    src={uploadUrl(act.thumb)}
    alt=""
    loading="lazy"
    onError={(event) => { event.currentTarget.style.display = 'none' }}
  />
) : null}
<span className="dateinfo nofMeta">
  {item.unread > 0 ? <b className="nofUnread">{item.unread > 99 ? '99+' : item.unread}</b> : null}
  <em>{formatNotificationDate(item.date)}</em>
</span>
{joinAsk ? (
  <span className="nofJoinActions">
    <button
      type="button"
      onClick={async (event) => {
        event.stopPropagation()
        try {
          await voteCommunityJoin(joinAsk.communityId, joinAsk.applicant, true)
          dispatch(actions.get_massage())
        } catch (err) {}
      }}
    >Yes</button>
  </span>
) : null}
{editing ? (
  <button
    type="button"
    className="nofDelete"
    aria-label="Delete conversation"
    onClick={(event) => {
      event.stopPropagation();
      dispatch(normallActions.delete_nof(item.id));
    }}
  >
    <BsTrash />
  </button>
) : null}

</div>
<hr />
</div>
)})}

</div>
</section>
  );
}
export default Notifications;
